import { render, staticRenderFns } from "./znZhuan.vue?vue&type=template&id=1fc5a6c3&scoped=true&"
import script from "./znZhuan.vue?vue&type=script&lang=js&"
export * from "./znZhuan.vue?vue&type=script&lang=js&"
import style0 from "./znZhuan.vue?vue&type=style&index=0&id=1fc5a6c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc5a6c3",
  null
  
)

export default component.exports